import { hashHistory, browserHistory } from 'react-router';
import { isElectronApp } from './services/crossPlatform/crossPlatformService';

let routerHistory = browserHistory;

if (isElectronApp()) {
  routerHistory = hashHistory;
}

if (process.env.NODE_ENV === 'test') routerHistory = { push: () => {} };

export default routerHistory;
